import { Edit, useForm } from '@refinedev/antd';
import { useGo } from '@refinedev/core';
import { message } from 'antd';
import { useEffect, useState } from 'react';

import FileData from '@/model/General/FileData';
import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';
import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';
import { RESOURCES } from '@/Resources';

import ReceptionForm from './ReceptionForm/ReceptionForm';

export const ReceptionEdit = () => {
  const go = useGo();
  const { packageItemRepository, receptionRepository } = useRepositoriesContext();
  const [packageItems, setPackageItems] = useState<PackageItem[]>([]);
  const [packageFiles, setPackageFiles] = useState<FileData[]>([]);
  const { formProps, saveButtonProps, query } = useForm<Shipment>({
    redirect: false,
    successNotification: {
      message: 'Recepción creada correctamente',
      type: 'success',
    },
    onMutationSuccess(receptionResponse) {
      Promise.all([
        packageItemRepository.savePackageItems(packageItems, receptionResponse.data.id),
        receptionRepository.saveFiles(packageFiles, receptionResponse.data.id),
      ])
        .then(() => {
          go({
            to: { resource: RESOURCES.RECEPTIONS, action: 'show', id: receptionResponse.data.id },
            type: 'replace',
          });
        })
        .catch(error => {
          message.error('Ocurrió un error al guardar los items o archivos de la recepción.');
          console.error('Error saving package items or files:', error);
        });
    },
  });

  useEffect(() => {
    if (formProps.initialValues?.photos) {
      const fileList = formProps.initialValues.photos.map(fileData => {
        return new FileData({
          id: fileData.id,
          title: fileData.description,
          file: fileData.photo,
        });
      });

      setPackageFiles(fileList);
    }
  }, [formProps.initialValues?.photos]);

  useEffect(() => {
    if (formProps?.initialValues?.id && formProps?.initialValues?.status) {
      if (formProps?.initialValues?.status != PACKAGE_STATES.PENDIENTE) {
        message.error('No se pueden editar recepciones que no estén en estado PENDIENTE');
        go({
          to: {
            resource: RESOURCES.RECEPTIONS,
            action: 'show',
            id: formProps?.initialValues?.id ?? '',
          },
          type: 'replace',
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formProps?.initialValues?.id]);

  return (
    <Edit saveButtonProps={saveButtonProps} isLoading={query?.isLoading || query?.isFetching}>
      {query?.data && (
        <ReceptionForm
          formProps={formProps}
          packageItems={packageItems}
          setPackageItems={setPackageItems}
          edit
        />
      )}
    </Edit>
  );
};
